import {IPossibleAnswerData} from './possibleanswer-data';

export const PossibleAnswerDefault: IPossibleAnswerData = {
    id: undefined,
    answer: '',
    score: 0,
    triggersRedFlag: false,
    libraryEntryIds: []
};
